import { OpenFeature } from '@openfeature/web-sdk'

import { flagKeys } from '@bettermode/flags/keys'

/**
 * A shared library package shouldn't read flags directly — `packages/flags/AGENTS.md`
 * puts client flag hooks in `packages/web/src/client/featureFlags/hooks/`. Flags are due
 * for a refactor, so the abstraction to fix that properly is deferred.
 *
 * Resolves against the global client: `useBooleanFlagValue` requires an
 * `OpenFeatureProvider` in the tree and throws without one, and `HtmlContent` also renders
 * in trees that have none (Storybook, the react-components test harness, dev-portal).
 * With no provider set, the SDK's Noop provider resolves the `true` default, so the
 * containment boundary stays on. The trade is that a flag change only lands on the next
 * render — `flags.json` is compiled in, and PostHog toggling takes effect on refresh.
 */
export const useHtmlContentBoundaryEnabled = (): boolean =>
  OpenFeature.getClient().getBooleanValue(
    flagKeys['html-content-boundary'],
    true,
  )
